import React, { useEffect } from 'react';
import Close from '../assets/Close';
import { motion, AnimatePresence } from 'framer-motion';
import toast from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useRTL } from '../hooks/useRTL';
import { useTranslation } from 'react-i18next';

const ContactInfo = ({ show, onClose }) => {
  const { t, i18n } = useTranslation();
  const isRTL = useRTL();

  const copyPhoneNumber = () => {
    navigator.clipboard.writeText(t('ContactInfo.Phone'));
    toast.success(t('ContactInfo.PhoneToast'), {
      position: 'top-center',
    });
  };

  const copyEmail = () => {
    navigator.clipboard.writeText(t('ContactInfo.Email'));
    toast.success(t('ContactInfo.EmailToast'), {
      position: 'top-center',
    });
  };

  // Move the language detection to a separate useEffect that runs once on mount
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const langParam = params.get('lang');

    if (langParam === 'ar') {
      i18n.changeLanguage('ar');
      document.documentElement.dir = 'rtl';
    } else {
      i18n.changeLanguage('en');
      document.documentElement.dir = 'ltr';
    }
  }, [i18n]);

  // Update document direction when RTL changes
  useEffect(() => {
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
  }, [isRTL]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  const anim = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, scale: 0.5, transition: { duration: 0.3 } },
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={`modal ${isRTL ? 'rtl' : 'ltr'}`}
          initial='hidden'
          animate='visible'
          exit='exit'
          variants={anim}
          style={{ zIndex: 9999 }}>
          <div>
            <div style={{ position: 'relative' }}>
              <div className='modal-x-btn' onClick={onClose}>
                <Close width={50} height={50} />
              </div>

              <div className='modal-main'>
                <div
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'grid',
                  }}>
                  <h1>{t('ContactInfo.IntroKey')}</h1>
                  <p style={{ marginTop: '20px', marginBottom: '20px' }}>
                    {t('ContactInfo.Subtitle')}
                  </p>

                  <div
                    className='ContactInfo'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: isRTL ? '0 0 0 20%' : '0 20% 0 0',
                      color: 'white',
                      marginBottom: '10px',
                      translate: isRTL ? '-35%' : '35%',
                    }}>
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{
                        marginRight: isRTL ? '0' : '10px',
                        marginLeft: isRTL ? '10px' : '0',
                        fontSize: '20px',
                      }}
                    />
                    <p
                      onClick={copyPhoneNumber}
                      style={{
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}>
                      {t('ContactInfo.Phone')}
                    </p>
                  </div>

                  <div
                    className='ContactInfo'
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'center',
                      translate: isRTL ? '-31%' : '31%',
                      padding: isRTL ? '0 0 0 20%' : '0 20% 0 0',
                      color: 'white',
                    }}>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{
                        marginRight: isRTL ? '0' : '10px',
                        marginLeft: isRTL ? '10px' : '0',
                        fontSize: '20px',
                      }}
                    />
                    <p
                      onClick={copyEmail}
                      style={{
                        cursor: 'pointer',
                        textDecoration: 'underline',
                      }}>
                      {t('ContactInfo.Email')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ContactInfo;
